module.exports = __webpack_public_path__ + "img/Slider FresadoraAres.1256291a.png";